import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomButton from '../CustomButton/CustomButton';
import ArrowBackIcon from '../Icons/ArrowBackIcon';
import ArrowDownwardIcon from '../Icons/ArrowDownwardIcon';
import ArrowForwardIcon from '../Icons/ArrowForwardIcon';
import CheckIcon from '../Icons/CheckIcon';

export const STEP_BUTTON_ACTION_PREV = 'STEP_BUTTON_ACTION_PREV';
export const STEP_BUTTON_ACTION_NEXT = 'STEP_BUTTON_ACTION_NEXT';
export const STEP_BUTTON_ACTION_SAVE = 'STEP_BUTTON_ACTION_SAVE';
export const STEP_BUTTON_ACTION_SAVE_AND_NEXT =
  'STEP_BUTTON_ACTION_SAVE_AND_NEXT';
export const STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN =
  'STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN';

class StepButton extends Component {
  getLabel() {
    switch (this.props.action) {
      case STEP_BUTTON_ACTION_PREV:
        return this.props.languageValues.anterior;
      case STEP_BUTTON_ACTION_NEXT:
        return this.props.languageValues.proxima;
      case STEP_BUTTON_ACTION_SAVE:
        return this.props.languageValues.concluirEtapa;
      case STEP_BUTTON_ACTION_SAVE_AND_NEXT:
      case STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN:
        return this.props.languageValues.concluirEAvancarEtapa;
      default:
        return undefined;
    }
  }

  getLeftIcon() {
    switch (this.props.action) {
      case STEP_BUTTON_ACTION_PREV:
        return <ArrowBackIcon />;
      default:
        return undefined;
    }
  }

  getRightIcon() {
    switch (this.props.action) {
      case STEP_BUTTON_ACTION_SAVE:
        return <CheckIcon />;
      case STEP_BUTTON_ACTION_NEXT:
      case STEP_BUTTON_ACTION_SAVE_AND_NEXT:
        return <ArrowForwardIcon />;
      case STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN:
        return <ArrowDownwardIcon />;
      default:
        return undefined;
    }
  }

  render() {
    let gettedProps = {
      ...this.props,
    };
    delete gettedProps.action;
    delete gettedProps.dispatch;
    delete gettedProps.languageValues;
    delete gettedProps.label;
    const allProps = {
      ...gettedProps,
      label: this.getLabel(),
      leftIcon: this.getLeftIcon(),
      rightIcon: this.getRightIcon(),
      onClick: (event) => {
        if (typeof this.props.onClick === 'function') {
          this.props.onClick(event);
        }
      },
    };
    return <CustomButton {...allProps} />;
  }
}

StepButton.propTypes = {
  ...Button.propTypes,
  action: PropTypes.oneOf([
    STEP_BUTTON_ACTION_PREV,
    STEP_BUTTON_ACTION_NEXT,
    STEP_BUTTON_ACTION_SAVE,
    STEP_BUTTON_ACTION_SAVE_AND_NEXT,
    STEP_BUTTON_ACTION_SAVE_AND_NEXT_TO_DOWN,
  ]),
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(StepButton);
